var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tab-detail" },
    [
      _c("div", { staticClass: "header" }, [
        _c("div", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("metaInsights.channelDetails"))),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "subtitle" }, [
          _vm._v(_vm._s(_vm.$t("metaInsights.manageChannel"))),
        ]),
      ]),
      _vm._v(" "),
      _c("a-form", [
        _c("div", { staticClass: "form-wrapper" }, [
          _c(
            "div",
            { staticClass: "input-wrapper" },
            [
              _c("label", [_vm._v(_vm._s(_vm.$t("message.channelName")))]),
              _vm._v(" "),
              _c("a-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'",
                  },
                ],
                attrs: {
                  placeholder: _vm.$t("message.channelName"),
                  name: "channelName",
                },
                model: {
                  value: _vm.clone.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.clone, "name", $$v)
                  },
                  expression: "clone.name",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.adAccount
            ? _c("div", { staticClass: "input-wrapper" }, [
                _c("label", [
                  _vm._v(_vm._s(_vm.$t("metaInsights.connectedAdAccount"))),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "ad-account-info" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("span", { staticClass: "muted" }, [
                      _vm._v(
                        _vm._s(_vm.$t("metaInsights.adAccountName")) + ":"
                      ),
                    ]),
                    _vm._v(" "),
                    _c("strong", [_vm._v(_vm._s(_vm.adAccount.name))]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("span", { staticClass: "muted" }, [_vm._v("ID:")]),
                    _vm._v(" "),
                    _c("code", [_vm._v(_vm._s(_vm.adAccount.id))]),
                  ]),
                  _vm._v(" "),
                  _vm.adAccount.business && _vm.adAccount.business.name
                    ? _c("div", { staticClass: "row" }, [
                        _c("span", { staticClass: "muted" }, [
                          _vm._v(_vm._s(_vm.$t("metaInsights.business")) + ":"),
                        ]),
                        _vm._v(" "),
                        _c("strong", [
                          _vm._v(_vm._s(_vm.adAccount.business.name)),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.adAccount.currency
                    ? _c("div", { staticClass: "row" }, [
                        _c("span", { staticClass: "muted" }, [
                          _vm._v(_vm._s(_vm.$t("metaInsights.currency")) + ":"),
                        ]),
                        _vm._v(" "),
                        _c("strong", [_vm._v(_vm._s(_vm.adAccount.currency))]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.adAccount.timezone_name
                    ? _c("div", { staticClass: "row" }, [
                        _c("span", { staticClass: "muted" }, [
                          _vm._v(_vm._s(_vm.$t("metaInsights.timezone")) + ":"),
                        ]),
                        _vm._v(" "),
                        _c("strong", [
                          _vm._v(_vm._s(_vm.adAccount.timezone_name)),
                        ]),
                      ])
                    : _vm._e(),
                ]),
              ])
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-footer" }, [
        _c(
          "div",
          { staticClass: "actions" },
          [
            _c(
              "a-button",
              {
                staticClass: "pr-confirm-btn",
                attrs: { type: "primary", disabled: _vm.loading },
                on: { click: _vm.handleSave },
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("message.update")) +
                    "\n            "
                ),
              ]
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }